export default "__VITE_PUBLIC_ASSET__7d5e251e__"